import { Controller } from "@hotwired/stimulus"

// The sticky publish bar + confirm modal. The email toggle drives the publish
// button label, the modal's email summary, and the hidden send_email field, so
// publishing reflects the toggle exactly. "Send test to me" POSTs a preview.
export default class extends Controller {
  static targets = [
    "emailToggle",
    "publishLabel",
    "dialog",
    "emailSummary",
    "sendEmailField",
    "testButton",
    "testLabel",
  ]

  connect() {
    this.toggle()
  }

  get emailOn() {
    return this.hasEmailToggleTarget ? this.emailToggleTarget.checked : false
  }

  toggle() {
    const on = this.emailOn
    if (this.hasPublishLabelTarget) {
      this.publishLabelTarget.textContent = on ? "Publish & email" : "Publish"
    }
    if (this.hasSendEmailFieldTarget) {
      this.sendEmailFieldTarget.value = on ? "1" : "0"
    }
    if (this.hasEmailSummaryTarget) {
      this.emailSummaryTarget.textContent = on
        ? this.emailSummaryTarget.dataset.on ||
          this.emailSummaryTarget.textContent
        : "No — public page only"
      this.emailSummaryTarget.classList.toggle("text-vivid-purple", on)
      this.emailSummaryTarget.classList.toggle("text-app-text", !on)
    }
  }

  openConfirm() {
    // Capture the "on" summary text once so toggling can restore it.
    if (
      this.hasEmailSummaryTarget &&
      !this.emailSummaryTarget.dataset.on &&
      this.emailOn
    ) {
      this.emailSummaryTarget.dataset.on = this.emailSummaryTarget.textContent
    }
    this.toggle()
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  closeConfirm() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  async sendTest(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    if (!url) return
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          Accept: "application/json",
        },
      })
      if (response.ok && this.hasTestLabelTarget) {
        this.testLabelTarget.textContent = "Test sent to you"
        button.classList.add("text-live")
        setTimeout(() => {
          this.testLabelTarget.textContent = "Send test to me"
          button.classList.remove("text-live")
        }, 2600)
      }
    } catch (e) {
      // no-op on failure
    }
  }

  disconnect() {
    if (this.hasDialogTarget && this.dialogTarget.open)
      this.dialogTarget.close()
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
